import Postmate from "postmate";
import { injectCssStyles } from "csi/utility/htmlUtility";
import { cnl } from "csi/typings";
import session from "csi/session";

interface PostMateChildApi {
	emit: (name: string, data: any) => void;
}

const C8_NAVIGATE = "C8-navigate";
let _childApi: PostMateChildApi;

/** navigate to the given node url */
function navigateToUrl(url: cnl): void {
	session.setLocationUrl(url);
}

/** connect to parent application when embedded in an iframe, returning API to emit messages */
export async function connectToIframeParent(): Promise<PostMateChildApi> {
	if (_childApi) {
		return _childApi;
	}

	const postmate = new Postmate.Model({
		height: () => document.body.offsetHeight,
		injectCssStyles,
		navigateToUrl,
	});

	return postmate.then((childApi: PostMateChildApi) => {
		_childApi = childApi;
		return childApi;
	});
}

/** notify parent application when navigate to new node */
export function onNavigateToUrl(url: cnl): void {
	_childApi?.emit(C8_NAVIGATE, url);
}

// DEBUG: leave here for testing embedding application within itself
//
// export function createIframe(container: HTMLElement) {
// 	const handshake = new Postmate({
// 		classListArray: [],
// 		container,
// 		name: "my-iframe-name",
// 		url: "http://laptop-ni066eat.corp.centricsoftware.com:8080/WebAccess/home.html",
// 	});
// 
// 	handshake.then((child) => {
// 		child.call("injectCssStyles", `.tableView { color: red; }`);
// 
// 		setTimeout(() => {
// 			child.call("navigateToUrl", "centric://APPAREL/Style/1");
// 		}, 5000);
// 
// 		child.on(C8_NAVIGATE, (url: cnl) => console.log(`Child navigated to ${url}`));
// 	});
// }
